// src/components/admin/hero/AdminHeroEditor.jsx
import React, { useState, useEffect } from 'react';
import fetchData from '../../../api/fetchData'; 
import { useTranslation } from 'react-i18next';
import { supportedLngs } from '../../../i18n';

function AdminHeroEditor({ onContentUpdated }) { 
  const { t, i18n } = useTranslation();
  const [allTranslations, setAllTranslations] = useState(null);
  const [editingLanguage, setEditingLanguage] = useState(i18n.language.split('-')[0] || 'ru');
  const [currentTitle, setCurrentTitle] = useState('');
  const [currentParagraph, setCurrentParagraph] = useState('');
  const [currentListItem, setCurrentListItem] = useState(''); 
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const [saveStatus, setSaveStatus] = useState({ message: '', type: '' });

  useEffect(() => {
    const loadHeroData = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await fetchData('/admin/hero/admin_get_hero_data.php', 'GET', null, { credentials: 'include' });
        if (response && response.status === 'success' && response.item) {
          setAllTranslations(response.item.translations || {});
        } else {
          setError(response?.message || 'Не удалось загрузить данные секции "Hero".');
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    loadHeroData();
  }, []); 


  useEffect(() => {
    if (allTranslations) {
      const langData = allTranslations[editingLanguage] || { title: '', paragraph: '', list_item: '' };
      setCurrentTitle(langData.title || '');
      setCurrentParagraph(langData.paragraph || '');
      setCurrentListItem(langData.list_item || '');
    }
  }, [editingLanguage, allTranslations]);

  const handleLanguageTabClick = (langCode) => {
    setEditingLanguage(langCode);
  };

  const handleSave = async (e) => {
    e.preventDefault();
     setIsSaving(true);
    setSaveStatus({ message: '', type: '' });

        const payload = {
      language_code: editingLanguage,
      title: currentTitle,
      paragraph: currentParagraph,
      list_item: currentListItem,
    };
        try {
      const response = await fetchData(
        '/admin/hero/admin_save_hero_data.php', // Правильный путь
        'POST',
        payload,
        { credentials: 'include' }
      );

      if (response && response.status === 'success') {
        setSaveStatus({ message: response.message, type: 'success' });
        if (onContentUpdated) onContentUpdated(); // Обновляем данные на всем сайте
      } else {
        setSaveStatus({ message: response?.message || 'Ошибка сохранения.', type: 'error' });
      }
    } catch (err) {
      setSaveStatus({ message: err.message, type: 'error' });
    } finally {
      setIsSaving(false);
      setTimeout(() => setSaveStatus({ message: '', type: '' }), 5000);
    }

  };

  if (loading) return <p>{t('messages.loading')}</p>;
  if (error) return <p>{t('messages.error.generic', { details: error })}</p>;

  return (
    <div className="admin-section-editor">
      <h4>{t('admin.hero.managerTitle', 'Управление секцией "Hero"')}</h4>
      <div className="language-tabs">
          {supportedLngs.map(langCode => (
        <button
            key={langCode}
            type="button"
            onClick={() => handleLanguageTabClick(langCode)}
            disabled={editingLanguage === langCode}
            className={editingLanguage === langCode ? 'active' : ''}
        >
            {langCode.toUpperCase()}
        </button>
    ))}
      </div>

      <form onSubmit={handleSave}>
        <fieldset>
          <legend>{t('admin.hero.translatableDataLegend', 'Переводимые данные для языка:')} {editingLanguage.toUpperCase()}</legend>
          <div>
            <label htmlFor="heroTitle">{t('admin.hero.titleLabel', 'Главный заголовок')}:</label>
            <input type="text" id="heroTitle" value={currentTitle} onChange={e => setCurrentTitle(e.target.value)} />
          </div>
          <div>
            <label htmlFor="heroParagraph">{t('admin.hero.paragraphLabel', 'Параграф/Подзаголовок')}:</label>
            <textarea id="heroParagraph" value={currentParagraph} onChange={e => setCurrentParagraph(e.target.value)} rows="3" />
          </div>
          <div>
            <label htmlFor="heroListItem">{t('admin.hero.listItemLabel', 'Текст на кнопке')}:</label>
            <input type="text" id="heroListItem" value={currentListItem} onChange={e => setCurrentListItem(e.target.value)} />
          </div>
        </fieldset>

        <button type="submit" disabled={isSaving} style={{ marginTop: '10px' }}>
          {isSaving ? t('admin.buttons.saving') : `${t('admin.buttons.save')} ${editingLanguage.toUpperCase()}`}
        </button>
      </form>

      {saveStatus.message && (
        <p className={`form-status-message ${saveStatus.type}`}>
          {saveStatus.message}
        </p>
      )}
    </div>
  );
}

export default AdminHeroEditor;